<template>
    <div class="kiaf-change-theme">
        <div class="theme-box">
            <div class="left-theme" @click="changeTheme(item.type)" v-for="item in themeList">
                <span class="img-box" :class="{'active-theme':activeTheme===item.type}"><img
                        :src="item.image"></span>
                <span>{{item.label}}</span>
            </div>
<!--            <div class="right-theme" @click="changeTheme('light')">-->
<!--                <span class="img-box" :class="{'active-theme':activeTheme==='light'}"><img-->
<!--                        :src="images.light"></span>-->
<!--                <span>{{labels.light}}</span>-->
<!--            </div>-->
        </div>
    </div>
</template>
<script>
  import Constants from '../../../utils/constants';
  import {postMessage} from '../../../utils/event-bus';

  export default {
    name: 'KiafChangeTheme',
    data() {
      return {
        activeTheme: '',
        themeList: [
          {
            label: '深色系',
            type: 'dark',
            image: './static/kiaf-baseui/images/theme-dark.png'
          },
          // {
          //   label: '蓝色系',
          //   type: 'blue',
          //   image: require('../../../theme/src/images/light-theme.png')
          // },
          {
            label: '浅色系',
            type: 'light',
            image: './static/kiaf-baseui/images/theme-light.png'
          }
        ]
        // images: {
        //   dark: require('../../../theme/src/images/dark-theme.png'),
        //   light: require('../../../theme/src/images/light-theme.png')
        // },
        // labels: {
        //   dark: '深色系',
        //   light: '浅色系'
        // }
      };
    },
    props: {
      customize: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    created() {
      console.log('this.customize>>>', this.customize);
      if (this.customize && this.customize.themeList) {
        this.themeList = this.customize.themeList;
        // if (this.customize.images) {
        //   let keys = Object.keys(this.customize.images);
        //   keys.forEach(key => {
        //     this.images[key] = this.customize.images[key];
        //   });
        // }
        // if (this.customize.labels) {
        //   let keys = Object.keys(this.customize.labels);
        //   keys.forEach(key => {
        //     this.labels[key] = this.customize.labels[key];
        //   });
        // }
      }
    },
    methods: {
      changeTheme(type) {
        this.activeTheme = type;
        postMessage(Constants.EVENT_BUS_CODE_CHANGE_THEME, {type: this.activeTheme});
        postMessage(Constants.EVENT_BUS_CODE_CHANGE_THEME, {type: this.activeTheme}, []);
      }
    }
  };
</script>
<style lang="scss">
    @import "index.scss";
</style>
